// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"7272d94d","513":"773d3f01","703":"22716be7"}[chunkId] + ".chunk.js";
};